import React from 'react';
import { VINReelsTable } from '../vinReelsModal/VINReelsTable';
import styled from 'styled-components/macro';
import { ISourceType, VideoSourceType } from './types';
import { VINReel } from 'lib/api/VINReels/types';

const Content = styled.div`
  padding-top: 32px;
`;
interface Props {
  onSelectVideo?: (videoSource: string, source: ISourceType) => void;
}

export const TabVINReels = ({ onSelectVideo }: Props) => {
  const handleOnSelectVideo = (vinReel: VINReel) => {
    const videoUrl = vinReel.videoUrl;
    if (videoUrl) {
      onSelectVideo?.(videoUrl, {
        sourceType: VideoSourceType.VINREEL,
        sourceId: Number(vinReel?.inventoryItem?.itemId) || 0,
      });
    }
  };
  return (
    <Content>
      <VINReelsTable
        onSelectVideo={handleOnSelectVideo}
        showAddToCovideo={false}
      />
    </Content>
  );
};
